import axios, { resHandle } from "@/plugins/axios";
/**
 * @description 获取大屏展示采集数据统计数据
 * @param vCom Vue组件
 * @param params 参数
 */
const GetAllData = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/stats/all", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取大屏展示气虚体症状特异性分析数据
 * @param vCom Vue组件
 * @param params 参数
 */
const GetTyx = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/stats/tyx", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取大屏展示各诊次体质占比分布数据
 * @param vCom Vue组件
 * @param params 参数
 */
const GetZhenci = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/stats/zhenci", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取大屏展示体质人数统计数据
 * @param vCom Vue组件
 * @param params 参数
 */
const GetTizhiRenshu = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/stats/tizhi", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取图片采集一级目录列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetImageCate1 = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/image/cate1", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 获取图片采集二级目录列表
 * @param vCom Vue组件
 * @param params 参数
 */
const GetImageCate2 = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/qixuti/image/cate2", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            });
        }).catch(() => {
            reject();
        });
    });
};
/**
 * @description 上传图片
 * @param vCom Vue组件
 * @param params 参数
 */
const UploadImage = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/henan/image", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};
/**
 * @description 获取图片
 * @param vCom Vue组件
 * @param params 参数
 */
const getImages = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/qixuti/two/images", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};
/**
 * @description 删除图片
 * @param vCom Vue组件
 * @param params 参数
 */
const delImages = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/center/qixuti/images", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};
/**
 * @description 上传视频
 * @param vCom Vue组件
 * @param params 参数
 */
const UploadVideo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/henan/video", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};
export { GetAllData, GetTyx, GetZhenci, GetTizhiRenshu, GetImageCate1, GetImageCate2, UploadImage, getImages, delImages, UploadVideo };
